<template>
  <div id="box">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="$t('pin.title')" />
        <Countdown
          :expiration="requestInfo.expiration"
          :stopTimer="stopTimer"
          @expired="expired"
          v-if="requestInfo.expiration != 0"
        />
        <p
          v-html="
            requestInfo.pinInputted
              ? $t('pin.dataProcessing')
              : $t('pin.description')
          "
          class="description center"
        />
        <div class="expandWrapper">
          <img
            v-svg-inline
            class="img loading"
            src="../assets/imgs/loadingWhite.svg"
            alt="loading"
          />
        </div>
      </div>
      <CustomButton
        :buttonType="'accent'"
        :customButtonTxt="$t('customButton.cancel')"
        @submit="cancel"
      />
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
import Countdown from "../components/countdown.vue";
export default {
  name: "Pin",
  components: {
    CustomButton,
    Countdown,
  },
  props: {
    requestInfo: {
      type: Object,
    },
  },
  data() {
    return {
      stopTimer: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("clearStatusTimer");
      this.$emit("cancel");
      this.$emit("navigate", { page: "Error", errorType: "canceled" });
    },
    expired() {
      this.$emit("clearStatusTimer");
      this.$emit("navigate", { page: "Error", errorType: "expired" });
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
  .wrapper
    +flex(space-between, center, row)
</style>
